import { render } from "./ServicesTwo.vue?vue&type=template&id=dcecb15e"
import script from "./ServicesTwo.vue?vue&type=script&lang=js"
export * from "./ServicesTwo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__